export interface ApiErrorResponseCamel {
  message: string
  errorCode: number
}

export interface ApiErrorResponsePascal {
  Message: string
  ErrorCode: number
}

export type KnownApiError = ApiErrorResponseCamel | ApiErrorResponsePascal

export class ApiError extends Error {
  code: number
  data?: unknown

  constructor(params: { code: number; message: string; data?: unknown }) {
    super(params.message)
    this.name = 'ApiError'
    this.code = params.code
    this.data = params.data
  }
}

export class AuthError extends Error {
  constructor(message = 'Unauthorized') {
    super(message)
    this.name = 'AuthError'
  }
}

export class NotFoundError extends Error {
  constructor(message = 'Not Found') {
    super(message)
    this.name = 'NotFoundError'
  }
}

export class NetworkError extends Error {
  constructor(message = 'Network error') {
    super(message)
    this.name = 'NetworkError'
  }
}
